module.exports = __webpack_public_path__ + "a55413c5e834b7c954f7f56d38d544ac.svg";